import { Component, Input, TemplateRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DefaultUrlSerializer } from '@angular/router';
import { timeout } from 'rxjs';

@Component({
  selector: 'app-custom-tool-tips',
  templateUrl: './custom-tool-tips.component.html',
  styleUrls: ['./custom-tool-tips.component.scss']
})

export class CustomToolTipsComponent {

  @Input() contentText?: string = undefined;
  @Input() link?: string = undefined;
  @Input() linkText?: string = undefined;
  sanitizedLink: string | undefined = undefined;

  isMouseInsideTooltip: boolean = true;

  constructor(
    protected sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    if (this.link) {
      this.sanitizedLink = this.link.replace(/%3F/g, '?').replace(/%3D/g, '=');
    }
  }

  public hoveringOverToolTip(toolTip: any, isHovering: boolean) {
    if (isHovering) {
      this.isMouseInsideTooltip = true;
    } else {
      this.isMouseInsideTooltip = false;
      setTimeout(() => {
        if (toolTip.isOpen && this.isMouseInsideTooltip == false) {
          toolTip.close();
        }
      }, 5000);
    }
  }

  public openTooltip(toolTip: any) {
    this.isMouseInsideTooltip = true;
    toolTip.open();
  }

  public delayedClosed(toolTip: any) {
    setTimeout(() => {
      if (toolTip.isOpen && this.isMouseInsideTooltip == false) {
        toolTip.close();
      }
    }, 5000);
    this.isMouseInsideTooltip = false;
  }
}
